// extracted by mini-css-extract-plugin
export var avatar = "_qd-3";
export var avatarContainer = "_qd-2";
export var avatarSpacer = "_qd-5";
export var avatarSpacerContainer = "_qd-4";
export var avatarStackContainer = "_qd-1";
export var bubble = "_qd-0";
export var remainderBubble = "_qd-6";